<template>
  <Loader :value="preparing" theme="default" :message="$t('creatingContracts') + '...'">
    <Card
      v-if="!preparing"
      theme="border"
      class="shop-signer-signing"
      :class="{ 'shop-signer-signing--active': current }"
    >
      <template #header>
        <h1>{{ $t('shopSigning') }}</h1>
      </template>
      <template #default>
        <Loader
          :value="promise"
          theme="default"
          :message="$t('loading', { resource: $t('shopContract').toLowerCase() })"
        >
          <div class="row center wrap g-1">
            <ApplicantCard v-for="(item, index) in signers" :value="item" theme="border" :key="index">
              <template #footer>
                <ButtonComponent
                  :label="$t(item.signUrl ? 'sign' : 'signed')"
                  :theme="item.signUrl ? 'primary' : 'success'"
                  :icon="item.signUrl ? ['fal', 'angle-right'] : 'check-circle'"
                  @click="startSigning(item)"
                />
              </template>
            </ApplicantCard>
          </div>
        </Loader>
      </template>
    </Card>
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import { mapActions, mapState } from 'vuex'

import Card from '@/components/Card'
import ApplicantCard from '@/components/Applicant'
import { Clone, GetJwtPayload } from '@/utils'
import { Initials } from '@/filters'

const meta = {
  order: 3,
  id: 'signing',
  label: i18n.tc('shopSigning'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    categories: Array,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler(val) {
        if (!val) return
        this.prepare()
      },
      immediate: true,
    },
    allSigned: {
      handler(val) {
        if (!val || !this.isActive) return
        this.$emit('update:isValid', true)
        this.$emit('completed')

        return this.$emit('next')
      },
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      current: null,
      preparing: true,
    }
  },
  computed: {
    ...mapState('Contract', ['promises']),
    signers() {
      let res = []
      if (!this.value) return []

      res.push(this.value.data.applicant)
      if (this.$path('value.data.hasCoApplicant')) res.push(this.value.data.coApplicant)

      return res
    },
    allSigned() {
      if (!this.signers.length) return false

      return this.signers.every(s => !s?.signUrl)
    },
  },
  methods: {
    ...mapActions('Contract', {
      async prepare(dispatch) {
        return dispatch('mutate', [
          { id: this.value.id, categories: this.categories },
          { mutation: 'ShopContractPrepareSigning', strategy: 'merge', transformPayload: false },
        ]).then(data => {
          this.parseJwt()
          this.preparing = false
          if (this.allSigned) this.$emit('next')
          return data
        })
      },
    }),
    startSigning(signer) {
      if (!signer?.signUrl) return
      this.current = signer

      window.location.href = signer.signUrl
    },
    parseJwt() {
      if (!this.$route.query['idfy-jwt']) return
      const token = GetJwtPayload(this.$route.query['idfy-jwt'])
      if (!token.SignSuccess) return
      const signer = this.signers.find(s => s.signerId === token.ExternalSignerId)
      if (!signer) return
      this.$set(signer, 'signUrl', null)

      if (this.allSigned) return this.$emit('next')
    },
  },
  filters: {
    Initials,
  },
  components: {
    Card,
    ApplicantCard,
  },
}
</script>

<style lang="scss">
.shop-signer-signing {
  border: none;

  &--active {
    .card__content {
      padding: 0;
    }
  }

  iframe {
    width: 100%;
    height: 800px;
  }

  .card__header {
    min-height: 125px;
  }

  h1 {
    margin: 0;
  }
}
</style>
